<template>
    <div>
        <div class="lb-project-content" @drop.prevent="addFile">
            <nav class="level">
                <div class="level-left">
                    <p v-if="communityParticipants" class="title is-4">
                        {{ communityParticipants.length }}
                        {{ $t('Community.participants_count') }}
                    </p>
                </div>
                <div class="level-right">
                    <p class="level-item">
                        <app-search-bar
                            v-model="searchValue"
                            class="lb-media-search-bar"
                        />
                    </p>
                </div>
            </nav>

            <div
                class="pt-3 columns is-multiline"
                style="padding-bottom: 10rem"
            >
                <div
                    v-for="participant in filteredItems"
                    :key="participant._id"
                    :ref="participant._id"
                    class="column is-3-desktop is-6-tablet is-12-mobile"
                >
                    <community-participant-card
                        :user="participant.profile"
                        :role="participant.permission"
                        class=""
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CommunityParticipantCard from '@/components/CommunityParticipantCard';
import CommunityCircle from '@/components/CommunityCircle';
import AppSearchBar from '@/components/AppSearchBar';
import _ from 'underscore';
import { Document } from 'flexsearch';
export default {
    components: {
        CommunityParticipantCard,
        AppSearchBar,
        CommunityCircle,
    },
    model: 'textSearch',
    data() {
        return {
            searchValue: '',
            items: this.$store.getters.community.participants || [],
            
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: ['profile:name',
                            'profile:description',
                            'profile:username',
                            'profile:email'],
                },
            })
            
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        community() {
            return this.$store.getters.community;
        },
        communityParticipants() {
            return this.community.participants;
        },
        activeUser() {
            return this.$store.getters.user;
        },
        isMember() {
            if (
                _.find(this.communityParticipants, (user) => {
                    return this.activeUser._id == user.profile;
                })
            ) {
                return true;
            }
            return false;
        },
        filteredItems() {
            if (this.searchValue) {
                //return this.searchIndex.search(this.searchValue);
                let items;
                items = this.items;
                //this.searchIndex.remove(this.items);
                //this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });

            }
            return this.communityParticipants;
        },
    },
    watch: {
        communityParticipants: 'buildSearchIndex',
    },
    mounted() {
        this.buildSearchIndex();
    },

    methods: {
        buildSearchIndex() {
            this.items.forEach((item) => {
                this.searchIndex.remove(item);
                this.searchIndex.add(item);
            });
        },
    },
};
</script>
<style scoped>
.lb-project-search-bar {
    border: 1px solid #d8d8d8;
    border-radius: 9999px;
}
</style>
